import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import PublicEventShowItem from '../components/pubevent/PublicEventShowItem';
import '../css/style.css';
import '../components/Home.css';

class PublicEventShowItemLayout extends Component {

    render(){
        const { params } = this.props.match
        return (
            <SimpleLayout>
                <PublicEventShowItem  id={params.id} />
            </SimpleLayout>              
        );
    }

}

export default PublicEventShowItemLayout;